import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import GlobalPartner from "./GlobalPartner";
import FinancePartner from "./FinancePartner";
import Buyer from "./Buyer";
import Seller from "./Seller";

const AmtplEntities = () => {
    const [activeTab, setActiveTab] = useState("Global Partner");
    const tabs = ["Global Partner","Finance Partner", "Buyer"];//, "Seller"

    const renderTabContent = () => {
        switch (activeTab) {
            case "Global Partner":
                return <GlobalPartner />;
            case "Finance Partner":
                return <FinancePartner />;
            case "Buyer":
                return <Buyer />;
            // case "Seller":
            //     return <Seller />;
            default:
                return <GlobalPartner />; // Added return statement
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab ? "active" : "notactive"}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AmtplEntities;